import { Navigate, Outlet, useLocation } from "react-router-dom"

import useAuth from "../hooks/useAuth"

const rolesMap = {
  user: "/user",
  secretary: "/user",
  admin: "/admin",
}

const PrivateRoutes = () => {
  const { isAuthenticated, role } = useAuth()
  const location = useLocation()
  const pathname = location.pathname

  if (!isAuthenticated) return <Navigate to="/login" replace />
  
  // Allow access to /payments route
  if (pathname.startsWith("/payments")) return <Outlet />
  
  // If role is not in rolesMap, redirect to /error
  if (!role || !rolesMap[role]) {
    return <Navigate to="/user" replace />
  }
  
  // Redirect user to their respective dashboard
  if (!pathname.startsWith(rolesMap[role])) return <Navigate to={rolesMap[role]} replace />
  
  return <Outlet />
}

export default PrivateRoutes